<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                   style="margin-right:10px"></i>部门列表</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <el-button type="primary"
                         style="margin-left:20px"
                         @click="add"
                         size="mini">新建部门</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <div style="overflow:auto">
                <el-table border
                          ref="multipleTable"
                          :data="tableData"
                          tooltip-effect="dark"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection">
                  </el-table-column>
                  <el-table-column prop="deptId"
                                   label="编号">
                  </el-table-column>
                  <el-table-column label="部门"
                                   prop="name">
                  </el-table-column>
                  <el-table-column prop="address"
                                   label="操作"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button @click="check1(scope.row)"
                                 type="text"
                                 size="small">编辑</el-button>
                      <el-button type="text"
                                 size="small"
                                 @click="deleteTable(scope.$index, tableData,scope.row.deptId)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div style="margin-top: 20px;padding:20px">
                <el-checkbox v-model="checked"
                             @change="toggleAllSelection">全选</el-checkbox>
                <el-button @click="deleteTables"
                          size="mini"
          style="margin-left:30px"
                           type="danger">批量删除</el-button>
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog title="新建部门"
               style="width:1200px;margin:auto"
               :visible.sync="dialogFormVisible">
      <el-form :model="form"
               ref="form"
               label-width="100px">
        <el-form-item label="部门名称:"
                      prop="name"
                      :rules="[
      { required: true, message: '不能为空'}
    ]">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label-width="0"
                      style="text-align:center">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitForm('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getdept, postdept, putdept, deletedept,deletesdept } from '../../API'
export default {
  data () {
    return {
      formInline: {},
      checked: false,
      dialogFormVisible: false,
      total: 0,
      current: 1,
      tableData: [],
      form: {
        name: ''
      },
      value: 0,
      multipleSelection: []
    }
  },
  created () {
    getdept().then(res => {
      if (res.code === 0) {
        this.total = res.data.total;
        this.current = res.data.current;
        this.tableData = res.data.records
      }
    })
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form.deptId != null)
          if (this.form.deptId !=null) {
            let params = this.form
            putdept(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              }
            })
            this.dialogFormVisible = false
          }
          else {
            let params = this.form
            postdept(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
              }
            })
            this.dialogFormVisible = false
            getdept().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }

        } else {
          return false;
        }
      });
    },
    add () {
      this.form = { name: '' }
      this.dialogFormVisible = true
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deletedept(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getdept().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteTables () {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].deptId)
        }
        deletesdept(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getdept().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit () {
      let params = {
        current: this.current
      }
      getdept(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
    check1 (row) {
      this.form = row
      this.dialogFormVisible = true
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    check (row) {
      this.$router.push({ path: '/CustomerManagement/CustomerInformation', query: { id: row.id } })
      localStorage.setItem('id', row.id)
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
/deep/.el-input {
  width: 217px;
}
/deep/ .el-table {
  max-width: 200%;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
  /deep/ .el-input {
    width: 50px;
  }
}
</style>